'use strict';
import React from 'react';
import {AgendaAssignment} from './AgendaAssignment';

export function EventAgenda(props) {
  const event = props.event;
  const task = event.task;
  const projectName = task.project && task.project.name || '';
  // TODO: manage internal layout with flexbox for grid with collapse to column behavior
  return (
    <span className="org-calendar-agenda">
      <span className="org-calendar-agenda-label">
        <span className="space-after">
          Name:
        </span>
        <a href={getUrl(task)}>
          {event.title}
        </a>
      </span>
      <span className="org-calendar-agenda-label">
        {`Project: ${task.assetName ? `${projectName} | ${task.assetName}` : projectName}`}
      </span>
      {AgendaAssignment(task.assignedTo)}
      {task.description ? (
        <span className="org-calendar-agenda-label space-above">
          Description:
        </span>
      ) : null}
      <p className="description">
        {task.description}
      </p>
    </span>
  );
}

function getUrl(task) {
  if (task.ast) {
    return `#/app/assets/tasks/${task.id}/details`;

  } else {
    return `#/app/projects/tasks/${task.id}/details`;

  }
}



// WEBPACK FOOTER //
// ./src/js/calendar/components/EventAgenda.js